var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "label",
        { staticClass: "v-label mb-0", class: { "dense-label": _vm.dense } },
        [_c("Label", { attrs: { param: _vm.param } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.dense ? "grv-input-dense" : "grv-input" },
        [
          _c("codeEditor", {
            attrs: {
              id: "",
              value: _vm.value,
              name: _vm.param.name,
              lang: "json",
              theme: "monokai",
              options: _vm.options
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:value", $event)
              },
              init: function($event) {
                return _vm.editorInit($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be3dbcc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3dbcc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/json.vue
// module id = null
// module chunks = 